module.exports = __webpack_public_path__ + "static/media/tasks.97cea909.svg";